import React from 'react';
import { OnChangeCallback } from '../../../../../../util/UtilityTypes'
import BoolInput from '../../../../../misc/BoolInput';
import EnumInput from '../../../../../misc/EnumInput';
import * as GoogleUser from '../../../../../../util/GoogleUserExportTypes';
import { update } from '../../../../../../util/Helper';
import { useTranslation } from 'react-i18next';

interface GoogleUserStaffOrganizationalUnitPolicyProps {
    organizationalUnitPolicy: GoogleUser.StaffOrganizationalUnitPolicy
    configurationType: string
    disabled?: boolean
    onChange: OnChangeCallback<GoogleUser.StaffOrganizationalUnitPolicy>
    validation: string[]
}

const GoogleUserStaffOrganizationalUnitPolicy: React.FC<GoogleUserStaffOrganizationalUnitPolicyProps> = (props) => {
    const { t } = useTranslation(['configuration']);

    return (<>
        <BoolInput
            title={t('googleUserExport.OuPolicy.createMissing')}
            name={`${props.configurationType}-organizationalUnitPolicy.createMissingOrganisationalUnits`}
            value={props.organizationalUnitPolicy.createMissingOrganisationalUnits}
            updateValue={(n, v) => update(n, props.organizationalUnitPolicy, { createMissingOrganisationalUnits: v }, props.onChange)}
            disabled={props.disabled}
        />

        <EnumInput
            title={t('googleUserExport.OuPolicy.structure')}
            name={`${props.configurationType}-organizationalUnitPolicy.organisationalUnit`}
            value={props.organizationalUnitPolicy.organisationalUnit}
            options={GoogleUser.staffOrganizationalUnit.map(x => ({value: x, text: t(`googleUserExport.OuPolicy.staffOuOptions.${x}`)}) )}
            onChange={(n, v) => update(n, props.organizationalUnitPolicy, { organisationalUnit: v }, props.onChange)}
            disabled={props.disabled}
        />

        <EnumInput
            title={t('googleUserExport.OuPolicy.inactiveUsers')}
            name={`${props.configurationType}-organizationalUnitPolicy.suspendedUsersOrganisationalUnit`}
            value={props.organizationalUnitPolicy.suspendedUsersOrganisationalUnit}
            options={GoogleUser.staffSuspendedOrganizationalUnit.map(x => ({ value: x, text: t(`googleUserExport.OuPolicy.staffSuspendedOuOptions.${x}`) }) )}
            onChange={(n, v) => update(n, props.organizationalUnitPolicy, { suspendedUsersOrganisationalUnit: v }, props.onChange)}
            disabled={props.disabled}
        />
    </>
    );
}

export default GoogleUserStaffOrganizationalUnitPolicy;
